export const ProjectData = [
  {
    id: 1,
    title: "SAINT",
    about:
      "SAINT sportx store is an ecommerce retail store that sells quality and affordable sportwears and gears for the relentless athletes, fans and sports enthusiast.",
    tags: [
      "Typescript",
      "NextJS",
      "Tailwind CSS",
      "DevOps",
      "Linux",
      "Github Actions",
      "Docker",
      "Docker Hub",
      "Firebase",
    ],
    demo: "https://saint.ng",
    github: "https://saint.ng",
    image:
      "https://fra.cloud.appwrite.io/v1/storage/buckets/69ce064f001eb106641b/files/6a181ee8000feada0876/view?project=69ce05d700314f848db5&mode=admin",
  },
  {
    id: 2,
    title: "Motion",
    about:
      "Motion is a WhatsApp Assistant that lets users book rides, order food, send parcels, and buy groceries—all through one simple chat.",
    tags: [
      "DevOps",
      "Linux",
      "AWS Lambda",
      "AWS S3",
      "AWS DynamoDB",
      "AWS API Gateway",
      "AWS Cloudwatch",
      "AWS IAM",
      "Jenkins",
      "Docker",
      "Docker Hub",
    ],
    demo: "https://motion-fe.vercel.app/",
    github: "https://github.com/khaymanii/Motion-BE",
    image:
      "https://github.com/user-attachments/assets/1ef031dc-abc4-485c-b7c6-5da4303149a6",
  },
  {
    id: 3,
    title: "Yard",
    about:
      "Yard is a WhatsApp-based AI real estate agent designed with a cloud-native, DevOps-driven architecture. It enables users to search for properties and schedule house inspections through a conversational WhatsApp interface, while leveraging automated CI/CD pipelines.",
    tags: [
      "DevOps",
      "Linux",
      "AWS CodePipeline",
      "AWS CodeBuild",
      "AWS CodeDeploy",
      "AWS Lambda",
      "AWS S3",
      "AWS DynamoDB",
      "AWS API Gateway",
      "AWS Cloudwatch",
      "AWS IAM",
    ],
    demo: "https://yard-six.vercel.app/",
    github: "https://github.com/khaymanii/Yard-BE",
    image:
      "https://github.com/user-attachments/assets/b602499c-fe62-4cbc-8778-37836c98ff78",
  },
  {
    id: 4,
    title: "FounderIQ",
    about:
      "FounderIQ is your personal AI co-founder and tech startup consultant/companion that helps you build and scale your tech startup.",
    tags: [
      "ReactJS",
      "Typescript",
      "Supabase",
      "PWA",
      "Web Development",
      "DevOps",
      "AWS",
      "Linux",
      "Github Actions",
      "Docker",
      "Docker Hub",
      "Ansible",
      "Terraform",
    ],
    demo: "https://www.fiq.vercel.app/",
    github: "https://github.com/khaymanii/FounderIQ",
    image:
      "https://github.com/user-attachments/assets/3c243e82-711f-4fbd-8412-ba2716afb060",
  },
  {
    id: 5,
    title: "AlienX",
    about:
      "A powerful VS Code snippet extension that generates UI Components of several UI libraries for web and mobile app  within seconds, right in your VS Code IDE. AlienX supports UI components of variuous notable UI libraries ranging from MaterialUI, GluestackUI and DaisyUI etc.",
    tags: [
      "JavaScript",
      "TypeScript",
      "VS Code Extension",
      "DevOps",
      "Linux",
      "Github Actions",
    ],
    demo: "https://marketplace.visualstudio.com/items?itemName=AlienUI.alienx",
    github: "https://github.com/khaymanii/AlienX/",
    image:
      "https://github.com/buywebteam/buyweb/blob/main/public/AlienX.png?raw=true",
  },
  {
    id: 6,
    title: "AlienUI Organization",
    about:
      "An open source Organization where next-gen developer tools and UI ibraries are built. AlienUI Org has four products; AlienUI, AlienUi React, AlienX and Alienicons.",
    tags: ["Tailwind Css", "Javascript", "React", "Web Development"],
    demo: "https://auiorg.vercel.app/",
    github: "https://github.com/AlienUI-Org/",
    image:
      "https://github.com/buywebteam/buyweb/blob/main/public/auiorg.png?raw=true",
  },
];
